import { h, Fragment } from 'preact';
import { CloseControl } from 'rendering/components/close_control';
import { ANNOTATION_EVENT } from 'constants/events';

export const closeable = Agent => class extends Agent {
    onClose = e => {
        const { id } = this.props;
        this.eventBus.emit(ANNOTATION_EVENT.REMOVE, id);
    }

    render() {
        return (
            <Fragment>
                <CloseControl onClick={ this.onClose } />
                { super.render() }
            </Fragment>
        )
    }
}